<footer class="wtw-footer">
  <div>
    <div class="wtw-logo" role="img" aria-label="WTW logo"></div>
    <nav>
      <ul class="wtw-footer--nav" role="list">
        <li *ngFor="let link of footerLinks">
          <a
            [href]="link.url"
            target="_blank"
            rel="noopener noreferrer"
            class="wtw-link wtw-typography-link--xs wtw-link-color--primary wtw-typography-font-weight--regular"
            [attr.aria-label]="link.ariaLabel"
          >
            {{ link.label }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
  <div>
    <div class="wtw-footer--copyright"><span>&copy; 2025 Willis Towers Watson</span></div>
  </div>
</footer>
